// Theme: founders-edition
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'founders-edition',
  name: 'FOUNDERS EDITION',
  tagline: 'FOUNDERS EDITION',
  description: 'Assinatura premium de origem com ouro classico e profundidade escura.',
  category: 'alternate-modes',
  tier: 'legendary',
  basePrice: 5250,
  swatches: ['#0F0C0A', '#C89B3C', '#1F1810', '#FFF0C2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 12%, transparent)'
    },
    shellClasses: 'font-sans theme-founders-edition'
  },
  colorVars: {
    '--accent': '#C89B3C',
    '--accent-foreground': '#0F0C0A',
    '--background': '#0F0C0A',
    '--border': '#5A3A1A',
    '--card': '#1F1810',
    '--card-border-active': 'rgba(200, 155, 60, 0.56)',
    '--card-completed': '#1F1810',
    '--card-foreground': '#FFF0C2',
    '--card-glow': 'rgba(200, 155, 60, 0.12)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0F0C0A',
    '--foreground': '#FFF0C2',
    '--hold-fill': '#C89B3C',
    '--input': '#1F1810',
    '--modal-bg': '#0F0C0A',
    '--modal-border': '#5A3A1A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#5A3A1A',
    '--muted-foreground': '#FFF0C2',
    '--nav-active': '#C89B3C',
    '--nav-bg': '#0F0C0A',
    '--popover': '#1F1810',
    '--popover-foreground': '#FFF0C2',
    '--primary': '#C89B3C',
    '--primary-foreground': '#0F0C0A',
    '--ring': '#C89B3C',
    '--secondary': '#5A3A1A',
    '--secondary-foreground': '#FFF0C2',
    '--streak': '#C89B3C',
    '--success': '#22C55E',
    '--success-foreground': '#0F0C0A',
    '--xp': '#C89B3C',
    '--xp-bg': '#1F1810'
  },
  resolvedVars: {
    '--accent': '#C89B3C',
    '--accent-foreground': '#0F0C0A',
    '--accent-foreground-hsl': '24 20% 5%',
    '--accent-foreground-oklch': 'from #0F0C0A l c h',
    '--accent-hsl': '41 56% 51%',
    '--accent-oklch': 'from #C89B3C l c h',
    '--background': '#0F0C0A',
    '--background-hsl': '24 20% 5%',
    '--background-oklch': 'from #0F0C0A l c h',
    '--border': '#5A3A1A',
    '--border-hsl': '30 55% 23%',
    '--border-oklch': 'from #5A3A1A l c h',
    '--border-w': '1px',
    '--card': '#1F1810',
    '--card-border-active': 'rgba(200, 155, 60, 0.56)',
    '--card-completed': '#1F1810',
    '--card-completed-hsl': '32 32% 9%',
    '--card-completed-oklch': 'from #1F1810 l c h',
    '--card-foreground': '#FFF0C2',
    '--card-foreground-hsl': '45 100% 88%',
    '--card-foreground-oklch': 'from #FFF0C2 l c h',
    '--card-glow': 'rgba(200, 155, 60, 0.12)',
    '--card-hsl': '32 32% 9%',
    '--card-oklch': 'from #1F1810 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0F0C0A',
    '--destructive-foreground-hsl': '24 20% 5%',
    '--destructive-foreground-oklch': 'from #0F0C0A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#FFF0C2',
    '--foreground-hsl': '45 100% 88%',
    '--foreground-oklch': 'from #FFF0C2 l c h',
    '--hold-fill': '#C89B3C',
    '--hold-fill-hsl': '41 56% 51%',
    '--hold-fill-oklch': 'from #C89B3C l c h',
    '--input': '#1F1810',
    '--input-hsl': '32 32% 9%',
    '--input-oklch': 'from #1F1810 l c h',
    '--modal-bg': '#0F0C0A',
    '--modal-bg-hsl': '24 20% 5%',
    '--modal-bg-oklch': 'from #0F0C0A l c h',
    '--modal-border': '#5A3A1A',
    '--modal-border-hsl': '30 55% 23%',
    '--modal-border-oklch': 'from #5A3A1A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#5A3A1A',
    '--muted-foreground': '#FFF0C2',
    '--muted-foreground-hsl': '45 100% 88%',
    '--muted-foreground-oklch': 'from #FFF0C2 l c h',
    '--muted-hsl': '30 55% 23%',
    '--muted-oklch': 'from #5A3A1A l c h',
    '--nav-active': '#C89B3C',
    '--nav-active-hsl': '41 56% 51%',
    '--nav-active-oklch': 'from #C89B3C l c h',
    '--nav-bg': '#0F0C0A',
    '--nav-bg-hsl': '24 20% 5%',
    '--nav-bg-oklch': 'from #0F0C0A l c h',
    '--popover': '#1F1810',
    '--popover-foreground': '#FFF0C2',
    '--popover-foreground-hsl': '45 100% 88%',
    '--popover-foreground-oklch': 'from #FFF0C2 l c h',
    '--popover-hsl': '32 32% 9%',
    '--popover-oklch': 'from #1F1810 l c h',
    '--primary': '#C89B3C',
    '--primary-foreground': '#0F0C0A',
    '--primary-foreground-hsl': '24 20% 5%',
    '--primary-foreground-oklch': 'from #0F0C0A l c h',
    '--primary-hsl': '41 56% 51%',
    '--primary-oklch': 'from #C89B3C l c h',
    '--radius': '14px',
    '--ring': '#C89B3C',
    '--ring-hsl': '41 56% 51%',
    '--ring-oklch': 'from #C89B3C l c h',
    '--secondary': '#5A3A1A',
    '--secondary-foreground': '#FFF0C2',
    '--secondary-foreground-hsl': '45 100% 88%',
    '--secondary-foreground-oklch': 'from #FFF0C2 l c h',
    '--secondary-hsl': '30 55% 23%',
    '--secondary-oklch': 'from #5A3A1A l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 12%, transparent)',
    '--streak': '#C89B3C',
    '--streak-hsl': '41 56% 51%',
    '--streak-oklch': 'from #C89B3C l c h',
    '--success': '#22C55E',
    '--success-foreground': '#0F0C0A',
    '--success-foreground-hsl': '24 20% 5%',
    '--success-foreground-oklch': 'from #0F0C0A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(41 56% 51% / 0.15)',
    '--xp': '#C89B3C',
    '--xp-bg': '#1F1810',
    '--xp-bg-hsl': '32 32% 9%',
    '--xp-bg-oklch': 'from #1F1810 l c h',
    '--xp-hsl': '41 56% 51%',
    '--xp-oklch': 'from #C89B3C l c h'
  }
}
